import { render, staticRenderFns } from "./PaymentBtnMethods.vue?vue&type=template&id=f2efcb30&scoped=true&"
import script from "./PaymentBtnMethods.vue?vue&type=script&lang=js&"
export * from "./PaymentBtnMethods.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBtnMethods.vue?vue&type=style&index=0&id=f2efcb30&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2efcb30",
  null
  
)

export default component.exports